import {apiClient} from 'core/apiClient';
import {AuditExportFormat} from 'types/audit-log';
import {RemarkingAuditEntry, RemarkingAuditPage, RemarkingAuditParams} from 'types/remarking-audit';

const URL = '/marking/remarking/audit-log';

export async function fetchRemarkingAuditLog(params: RemarkingAuditParams) {
    return (await apiClient.get<RemarkingAuditPage>(URL, {params})).data;
}

export async function fetchRemarkingAuditEvent(id: string) {
    return (await apiClient.get<RemarkingAuditEntry>(`${URL}/${id}`)).data;
}

export async function exportRemarkingAuditEvent(id: string) {
    return (await apiClient.get<Blob>(`${URL}/${id}/export`, {responseType: 'blob'})).data;
}

export async function exportRemarkingAuditLog(
    params: RemarkingAuditParams & {format: AuditExportFormat; from: string; to: string},
) {
    return {
        data: (await apiClient.get<Blob>(`${URL}/export`, {params, responseType: 'blob'})).data,
    };
}
